import { createRouter, createWebHistory } from "vue-router";

const HomePage = () => import(/* webpackChunkName: "home" */ "../../features/home/HomePage.vue");
const SuccessPage = () => import(/* webpackChunkName: "success" */ "../../pages/SuccessPage.vue");
const NotFoundPage = () =>
    import(/* webpackChunkName: "notfound" */ "../../pages/NotFoundPage.vue");

const ROUTER_PATH = {
    HOME: "/",
    SUCCESS: "/success",
    NOTFOUND: "/:pathMatch(.*)*",
};

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: ROUTER_PATH.HOME,
            name: "home",
            component: HomePage,
        },
        {
            path: ROUTER_PATH.SUCCESS,
            name: "success",
            component: SuccessPage,
        },
        {
            path: ROUTER_PATH.NOTFOUND,
            name: "notfound",
            component: NotFoundPage,
        },
    ],
});

export default router;
